//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { UIA_RIGHTS_REQUEST } from '@uia/rights-request/rights-request-constants';
import { IUIARightsRequestState } from '@uia/rights-request/rights-request-model';

const initialState: IUIARightsRequestState = {
  canGraphRequestRights: false,
  bypassRightsRequest: false,
  rightsRequestActive: false,
  graphRightsRequestActive: false,
  skipRightsRequestActive: false,
};

export default function RightsRequestReducer(
  state: IUIARightsRequestState = initialState,
  action,
): IUIARightsRequestState {
  switch (action.type) {
    case UIA_RIGHTS_REQUEST.GRAPH_RIGHTS_CAPABILITY:
      return {
        ...state,
        canGraphRequestRights: action.payload,
      };

    case UIA_RIGHTS_REQUEST.BYPASS_RIGHTS_REQUEST:
      return {
        ...state,
        bypassRightsRequest: action.payload,
      };

    case UIA_RIGHTS_REQUEST.SET_CUSTOM_RIGHTS_REQUEST:
      return {
        ...state,
        customRightsRequest: {
          approvalPhrase: action.payload.approvalPhrase,
          requestForRightsMessage: action.payload.requestForRightsMessage,
          bypassRightsRequest: action.payload.bypassRightsRequest,
        },
      };

    case UIA_RIGHTS_REQUEST.GRAPH_RIGHTS_REQUEST_STARTED:
      return {
        ...state,
        graphRightsRequestActive: true,
      };

    case UIA_RIGHTS_REQUEST.GRAPH_RIGHTS_REQUEST_ENDED:
      return {
        ...state,
        graphRightsRequestActive: false,
      };

    case UIA_RIGHTS_REQUEST.RIGHTS_REQUEST_STARTED:
      return {
        ...state,
        rightsRequestActive: true,
      };

    case UIA_RIGHTS_REQUEST.RIGHTS_REQUEST_ENDED:
      return {
        ...state,
        rightsRequestActive: false,
      };

    case UIA_RIGHTS_REQUEST.SKIP_RIGHTS_REQUEST_STARTED:
      return {
        ...state,
        skipRightsRequestActive: true,
      };

    case UIA_RIGHTS_REQUEST.SKIP_RIGHTS_REQUEST_ENDED:
      return {
        ...state,
        skipRightsRequestActive: false,
      };

    case UIA_RIGHTS_REQUEST.RIGHTS_STATUS_CHANGED:
      return {
        ...state,
        lastUpdatedStatus: action.payload,
      };

    default:
      return state;
  }
}
